import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setMessage('感谢订阅！我们会定期为您推送精选育儿内容。');
      return;
    }

    setStatus('submitting');
    setMessage('');

    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9spbep4ne17ei0sdlk0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      const serverMsg = (parsed?.meta as Record<string, string>)?.message || (parsed as Record<string, string>)?.message || text;

      if (res.ok && (parsed as Record<string, string>)?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会定期为您推送精选育儿内容。');
        setEmail('');
      } else if (typeof serverMsg === 'string' && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'))) {
        setStatus('error');
        setMessage('提交失败，请稍后再试。');
      } else {
        setStatus('error');
        setMessage(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试。');
    }
  };

  return (
    <section className="bg-accent-100/50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-16 md:py-20 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          订阅育儿指南
        </h2>
        <p className="mt-2 text-sm md:text-base text-foreground-500 mb-8">
          每周获取精选育儿知识、专家建议和妈妈故事，陪伴你的育儿旅程
        </p>

        <form
          data-readdy-form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
        >
          <input
            className="honeypot-field"
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入你的邮箱地址"
            required
            className="w-full sm:w-auto flex-1 px-5 py-3 rounded-full border border-background-300/60 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'submitting'}
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors disabled:opacity-60 cursor-pointer whitespace-nowrap"
          >
            {status === 'submitting' ? '提交中...' : '免费订阅'}
          </button>
        </form>

        {message && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-secondary-700' : 'text-primary-600'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}